module.exports = __webpack_public_path__ + "static/media/hearts-right.2e479090.png";